document.addEventListener('touchstart', function(){}, { passive: true });

//HARD BLOCK direct access to splash/home
(function () {
  var hash = window.location.hash.replace('#', '');

  if (hash === 'splash' || hash === 'home') {
    window.location.replace('/');
  }
})();
class SceneSlider {
  constructor(root) {
    this.root = root;
    this.id = root.id;
    this.track = root.querySelector('.slider-track');
    this.slides = root.querySelectorAll('.slide');
    this.index = 0;

    this.bindControls();
    this.update();
  }

  bindControls() {
    // Find external controls that target this slider
    this.prevBtns = document.querySelectorAll(
      `[data-slider-prev][data-slider-target="${this.id}"]`
    );

    this.nextBtns = document.querySelectorAll(
      `[data-slider-next][data-slider-target="${this.id}"]`
    );

    this.onPrev = () => this.prev();
    this.onNext = () => this.next();

    this.prevBtns.forEach(btn =>
      btn.addEventListener('click', this.onPrev)
    );

    this.nextBtns.forEach(btn =>
      btn.addEventListener('click', this.onNext)
    );
  }

  update() {
    this.track.style.transform = `translateX(-${this.index * 100}%)`;
  }

  next() {
    this.index = (this.index + 1) % this.slides.length;
    this.update();
  }

  prev() {
    this.index =
      (this.index - 1 + this.slides.length) % this.slides.length;
    this.update();
  }

  destroy() {
    this.prevBtns.forEach(btn =>
      btn.removeEventListener('click', this.onPrev)
    );

    this.nextBtns.forEach(btn =>
      btn.removeEventListener('click', this.onNext)
    );
  }
}


(function () {
  const ua = navigator.userAgent.toLowerCase();
  const html = document.documentElement;

  const isMobile = /android|iphone|ipod/i.test(ua);

  const isTablet =
    /ipad|tablet/i.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

if (isMobile || isTablet) {
  html.classList.add('is-mobile');
} else {
  html.classList.add('is-desktop'); // ✅ NEW
}

if (isTablet) html.classList.add('is-tablet');

  // OS
  if (/android/i.test(ua)) html.classList.add('is-android');
  if (/iphone|ipad|ipod/i.test(ua) || isTablet) html.classList.add('is-ios');

  // Browser
  const isSamsung = ua.includes('samsungbrowser');
  const isEdge = ua.includes('edg/') || ua.includes('edga/');
  const isChrome = ua.includes('chrome') && !isEdge && !isSamsung;
  const isSafari = ua.includes('safari') && !ua.includes('chrome');

  if (isSamsung) html.classList.add('is-samsung');
  if (isEdge) html.classList.add('is-edge');
  if (isChrome) html.classList.add('is-chrome');
  if (isSafari) html.classList.add('is-safari');
})();

// =====================================================
// 1️⃣ GLOBAL CONFIG
// =====================================================

// Scenes where UI (header, sidebar, footer) must be hidden
var UI_HIDDEN_SCENES = [
  'intro',
  'splash',
  'chapter-1-intro',
  'chapter-2-intro',
  'chapter-3-intro',
  'chapter-4-intro',
  'chapter-5-intro',
  'chapter-6-intro'
];

// Scenes where scene loader is skipped
var SCENE_SKIP_PRELOADER = ['intro', 'splash', 'home'];


// =====================================================
// 2️⃣ MAIN APP OBJECT
// =====================================================

var app = {
  scenes: [],
  currentScene: null,
  activeVideo: null,
  hasUserInteracted: false,
  isDirectEntry: false,

  // Tracks preloaded video URLs (HARD dedupe)
  preloadedVideos: new Set(),

  screenMode: window.innerWidth < 768 ? 'mobile' : 'desktop',

  // ---------------------------------------------------
  // INIT
  // ---------------------------------------------------
  init: function () {
    this.cache();
    this.bindEvents();
    this.hideUI();
    this.triggerNav();
    this.window();

    if (sessionStorage.getItem('userInteracted') === '1') {
      this.hasUserInteracted = true;
    }

    document.addEventListener('click', function () {
      app.hasUserInteracted = true;
    
      // 🔑 Persist across page navigation
      sessionStorage.setItem('userInteracted', '1');
    }, { once: true });

    // 🔗 Hash has priority over body attribute
    var hashScene = window.location.hash.replace('#', '');

    // Prevent direct access to splash/home on refresh
    if (hashScene === 'splash' || hashScene === 'home') {
      window.location.replace('/');
      return;
    }

    var startScene =
      hashScene ||
      document.body.getAttribute('data-start-scene') ||
      'intro';

    // ✅ Mark direct page entry (no user gesture yet)
    this.isDirectEntry = startScene !== 'intro';

    // Restore user interaction from previous page click
    if (sessionStorage.getItem('userInteracted') === '1') {
      this.hasUserInteracted = true;
    }

    this.goToScene(startScene);

    sessionStorage.removeItem('userInteracted');

    $(document).on('click', '[data-target]', function () {
      var target = $(this).data('target');
      var offset = 0; // sticky header height
    
      if (!$(target).length) return;
    
      $('html, body').scrollTop($(target).offset().top - offset);
    });
    

    document.addEventListener('touchstart', () => {
      if (app.activeVideo) {
        app.activeVideo.play().catch(() => {});
      }
    }, { once: true });
    
  },

  window: function(){

    $(window).scroll(function(){
      
        var h = $(window).height() * 2;
    
        if ($(this).scrollTop() >=250) {
            $('body').addClass('scroll');
        } else {
            $('body').removeClass('scroll');
        }         
    
    
    });

      // Smooth scroll to top
      $('#to-top').click(function() {
        $('html, body').animate({ scrollTop: 0 }, 0);
        return false;
      });

  },

  isInternalNavigation: false,
  // ---------------------------------------------------
  // CACHE DOM
  // ---------------------------------------------------
  cache: function () {
    this.$sections = $('section');
  },

  // ---------------------------------------------------
  // WINDOW RESIZE HANDLER
  // ---------------------------------------------------
  handleResize: function () {
    const newMode = window.innerWidth < 768 ? 'mobile' : 'desktop';
    const isLandscape = window.innerWidth > window.innerHeight;
  
    // Detect orientation change
    if (this.lastOrientation === undefined) {
      this.lastOrientation = isLandscape;
    }
  
    const orientationChanged = this.lastOrientation !== isLandscape;
  
    this.lastOrientation = isLandscape;
  
    // Only act if mode OR orientation changed
    if (newMode === this.screenMode && !orientationChanged) return;
  
    console.log('[Scene] Resize/orientation change detected');
  
    this.screenMode = newMode;
  
    // 🔄 Reset preload cache
    this.preloadedVideos.clear();
  
    // 🔁 Reload current video
    if (this.currentScene && this.currentScene.type === 'video') {
      this.destroyVideo();
      this.loadVideo(this.currentScene);
    }
  },
  

  // ---------------------------------------------------
  // POPUP NAV (BURGER / OVERLAY)
  // ---------------------------------------------------
  triggerNav: function () {
  var $popup   = $('#popup-menu'),
      $navigate = $('.trigger-nav a'),
      $exit    = $('#popup-menu .exit'),
      $overlay = $('#popup-menu .overlay'),
      $menuExit = $('.trigger-nav a.exit'),
      $menu    = $('#popup-menu .abs-menu');

  // TOGGLE OPEN / CLOSE
  $navigate.on('click', function (e) {
    e.preventDefault();

    var $parent = $(this).parent(); // .trigger-nav

    // IF already open → CLOSE
    if ($parent.hasClass('mobile-nav-show')) {
      $popup.removeClass('show');
      $parent.removeClass('mobile-nav-show');
      $('body').removeClass('show-menu')
    } 
    // ELSE → OPEN
    else {
      $popup.addClass('show');
      $('.trigger-nav').removeClass('mobile-nav-show'); // safety reset
      $parent.addClass('mobile-nav-show');

      $('body').addClass('show-menu')
    }
  });

  // CLOSE via exit or overlay
  $exit.add($overlay).on('click', function () {
    $popup.removeClass('show');
    $('.trigger-nav').removeClass('mobile-nav-show');
    $('body').removeClass('show-menu')
  });



  // Prevent close when clicking inside menu
  $menu.on('click', function (e) {
    e.stopPropagation();
  });
}
,

  // ---------------------------------------------------
  // UI VISIBILITY
  // ---------------------------------------------------
  updateUIState: function (sceneId) {
    if (UI_HIDDEN_SCENES.includes(sceneId)) {
      this.hideUI();
    } else {
      this.showUI();
    }
  },

  showUI: function () {
    $('.app-ui').addClass('is-active');
  },

  hideUI: function () {
    $('.app-ui').removeClass('is-active');
  },

  // ---------------------------------------------------
  // EVENTS
  // ---------------------------------------------------
  bindEvents: function () {
    var self = this;

    // Scene navigation buttons
    $(document).on('click', '[data-next]', function (e) {
      e.preventDefault();
    
      app.hasUserInteracted = true;
      app.isInternalNavigation = true; // ✅ SPA navigation
    
      var next = $(this).data('next');
      if (next) app.goToScene(next);
    });


    // Normal page links → remember user interaction across page load
    $(document).on('click', 'a[href]', function () {
      sessionStorage.setItem('userInteracted', '1');
    });
    
    

    // Resize handler
    $(window).on('resize', function () {
      self.handleResize();
    });

    // Sidebar hover predictive preload (desktop only)
    $('#app-sidebar').on('mouseenter focus', 'a[data-next]', function () {
      if (window.innerWidth < 768) return;
    
      var target = $(this).data('next');
      app.preloadSceneVideo(target, 'prefetch');
    });
    
  },

  // ---------------------------------------------------
  // VIDEO SOURCE RESOLUTION
  // ---------------------------------------------------
  getVideoSrc: function (scene) {
    if (!scene.video) return null;
  
    if (typeof scene.video === 'string') {
      return scene.video;
    }
  
    const html = document.documentElement;
  
    const isMobileClass = html.classList.contains('is-mobile');
    const isTablet = html.classList.contains('is-tablet');
  
    const isSmallScreen = window.innerWidth < 767;
    const isLandscape = window.matchMedia("(orientation: landscape)").matches;
  
    // 📱 Phones OR small screens → mobile video
    if (isSmallScreen || (isMobileClass && !isTablet)) {
      return scene.video.mobile;
    }
  
    // 📲 Tablets (iPad behavior)
    if (isTablet) {
      return isLandscape
        ? scene.video.desktop   // landscape → desktop
        : scene.video.mobile;   // portrait → mobile
    }
  
    // 💻 Desktop
    return scene.video.desktop;
  },

  // ---------------------------------------------------
  // SCENE NAVIGATION
  // ---------------------------------------------------
  goToScene: function (sceneId) {
    if (this.currentScene && this.currentScene.id === sceneId) return;

        // ▶ Destroy sliders from previous scene
    if (this.currentScene) {
      var prevSceneEl = document.getElementById(this.currentScene.id);

      if (prevSceneEl) {
        prevSceneEl.querySelectorAll('[data-slider]').forEach(sliderEl => {
          if (sliderEl._slider) {
            sliderEl._slider.destroy();
            delete sliderEl._slider;
          }
        });
      }
    }


    this.destroyVideo();

    var scene = this.getScene(sceneId);
    if (!scene) return;

    this.currentScene = scene;
    

    // 🔮 Predictive preload (desktop only)
    if (window.innerWidth >= 768) {
      var index = this.scenes.findIndex(s => s.id === sceneId);

      // 🔥 NEXT scene → preload (highest priority)
      var next = this.scenes[index + 1];
      if (next && next.type === 'video') {
        this.preloadSceneVideo(next.id, 'preload');
      }

      // 🧊 Next + 2 → prefetch (idle bandwidth)
      var next2 = this.scenes[index + 2];
      if (next2 && next2.type === 'video') {
        this.preloadSceneVideo(next2.id, 'prefetch');
      }

      // 🧊 Previous scene → prefetch (back navigation)
      var prev = this.scenes[index - 1];
      if (prev && prev.type === 'video') {
        this.preloadSceneVideo(prev.id, 'prefetch');
      }
    }


    // 🔗 Update URL hash (no duplicate push)
    if(
      this.isInternalNavigation &&
      location.hash.replace('#', '') !== sceneId
    ) {
      history.pushState(null, '', '#' + sceneId);
    }

    // UI + nav state
    this.updateUIState(scene.id);
    this.updateActiveNav(scene.id);

    // Activate section
    this.$sections.removeClass('active');
    $('#' + scene.id).addClass('active');

    // ▶ Init sliders inside active scene (generic)
    var activeSceneEl = document.getElementById(scene.id);

    if (activeSceneEl) {
      activeSceneEl.querySelectorAll('[data-slider]').forEach(sliderEl => {
        if (!sliderEl._slider) {
          sliderEl._slider = new SceneSlider(sliderEl);
        }
      });
    }


    if (scene.type === 'video') {
      this.loadVideo(scene);
    }

    this.isInternalNavigation = false;
  },

  // ---------------------------------------------------
  // SIDEBAR ACTIVE STATE
  // ---------------------------------------------------
  updateActiveNav: function (sceneId) {
    $('#app-sidebar .nav li').removeClass('is-active');

    $('#app-sidebar .nav a[data-next="' + sceneId + '"]')
      .closest('li')
      .addClass('is-active');
  },

  // ---------------------------------------------------
  // SCENE LOOKUP
  // ---------------------------------------------------
  getScene: function (id) {
    return this.scenes.find(scene => scene.id === id);
  },

  // ---------------------------------------------------
  // VIDEO LOADER (MAIN)
  // ---------------------------------------------------
  loadVideo: function (scene) {
    var container = document.querySelector('#' + scene.id + ' .scene-content');
    if (!container) return;

    // -------- Scene Loader (single global instance) --------
    var skipLoader = SCENE_SKIP_PRELOADER.includes(scene.id);
    var loaderEl = document.getElementById('global-scene-loader');
    var loaderVideo = document.getElementById('scene-loader-video');

    if (!skipLoader && loaderEl) {
      container.prepend(loaderEl);
      loaderEl.classList.remove('is-hidden');

      if (loaderVideo) {
        loaderVideo.muted = true;
        loaderVideo.loop = true;
        loaderVideo.play().catch(() => {
          setTimeout(() => loaderVideo.play().catch(() => {}), 100);
        });
      }
    }

    // -------- Main Video --------
    var videoSrc = this.getVideoSrc(scene);
    if (!videoSrc) return;

    var video = document.createElement('video');

   
    video.src = videoSrc;
    video.load(); // ✅ ADD THIS
    
    video.muted = true;
    video.setAttribute('muted', '');
    
    video.autoplay = true;
    video.setAttribute('autoplay', '');
    
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    
    video.preload = 'auto';
    video.loop = scene.loop === true;
    
    container.prepend(video);
    this.activeVideo = video;

    safePlay(video);

    // 🎯 SCENE-BASED AUDIO CONTROL

    // 1️⃣ INTRO → always muted autoplay (no interaction needed)
    if (scene.id === 'intro') {
      video.muted = true;
      video.setAttribute('muted', '');
    }

    // 2️⃣ SPLASH + HOMEPAGE SCENES → allow audio if user already interacted
    else if (
      scene.id === 'splash' ||
      scene.id === 'home' ||
      scene.id === 'welcome' ||
      scene.id === 'who-we-are' ||
      scene.id === 'business-overview' ||
      scene.id === 'financial-highlights'
    ) {
      if (this.hasUserInteracted) {
        video.muted = false;
        video.removeAttribute('muted');

        if (scene.volume !== undefined) {
          video.volume = scene.volume;
        }
      }
    }

    // 3️⃣ CHAPTER PAGES → require tap (iOS-safe)
    
    
    else {
      const isAndroid = document.documentElement.classList.contains('is-android');
      const isIOS = document.documentElement.classList.contains('is-ios');
    
      // ✅ ANDROID → allow audio immediately if user interacted
      if (isAndroid && this.hasUserInteracted) {
        video.muted = false;
        video.removeAttribute('muted');
    
        if (scene.volume !== undefined) {
          video.volume = scene.volume;
        }
    
        video.play().catch(() => {});
      }
    
      // 🍎 iOS → requires tap (strict policy)
      else if (isIOS) {
        video.muted = true;
        video.setAttribute('muted', '');
    
        const unlockVideo = () => {
          video.muted = false;
          video.removeAttribute('muted');
    
          if (scene.volume !== undefined) {
            video.volume = scene.volume;
          }
    
          video.play().catch(() => {});
        };
    
        document.addEventListener('touchstart', unlockVideo, { once: true });
        document.addEventListener('click', unlockVideo, { once: true });
      }
    
      // 💻 Desktop fallback
      else {
        if (this.hasUserInteracted) {
          video.muted = false;
    
          if (scene.volume !== undefined) {
            video.volume = scene.volume;
          }
        }
      }
    }
    
    
    // ✅ FIXED PLAY (NO setTimeout)
    const playPromise = video.play();
    
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        requestAnimationFrame(() => {
          video.play().catch(() => {});
        });
      });
    }


   


    // ▶ Overlay videos (HUDs, etc.)
    requestAnimationFrame(() => {
      container.querySelectorAll('.video-overlay').forEach(overlay => {
        overlay.muted = true;
        overlay.loop = true;
        overlay.play().catch(() => {
          setTimeout(() => overlay.play().catch(() => {}), 100);
        });
      });
    });

   



    // ▶ Hide loader when ready
    video.addEventListener('canplay', () => {
      if (!skipLoader && loaderEl) {
        loaderEl.classList.add('is-hidden');
        if (loaderVideo) {
          loaderVideo.pause();
          loaderVideo.currentTime = 0;
        }
      }
    }, { once: true });

    // Safety fallback
    if (!skipLoader && loaderEl) {
      setTimeout(() => {
        loaderEl.classList.add('is-hidden');
        if (loaderVideo) {
          loaderVideo.pause();
          loaderVideo.currentTime = 0;
        }
      }, 5000);
    }




    // ▶ Auto navigation on video end
      if (scene.trigger === 'ended' && scene.next) {
        video.addEventListener('ended', () => {
          if (scene.id === 'splash') {
            this.showUI();

            // ✅ only splash should update URL to #home
            this.isInternalNavigation = true;
          }

          this.goToScene(scene.next);
        }, { once: true });
      }

    // Reset direct-entry flag
    this.isDirectEntry = false;




    function safePlay(video) {
      if (!video) return;
    
      const tryPlay = () => {
        const p = video.play();
        if (p !== undefined) {
          p.catch(() => {
            // retry once (Safari fix)
            setTimeout(() => {
              video.play().catch(() => {});
            }, 200);
          });
        }
      };
    
      // 🔑 iOS needs readiness
      video.addEventListener('loadeddata', () => {
        requestAnimationFrame(tryPlay);
      }, { once: true });
    
      // fallback
      setTimeout(tryPlay, 400);
    }
  },

  // ---------------------------------------------------
  // PRELOAD SCENE VIDEO (SAFE, DEDUPED)
  // ---------------------------------------------------
  preloadSceneVideo: function (sceneId, mode = 'preload') {
    if (window.innerWidth < 768) return;
  
    var scene = this.getScene(sceneId);
    if (!scene || scene.type !== 'video') return;
  
    var src = this.getVideoSrc(scene);
    if (!src) return;
  
    // ✅ HARD DEDUPLICATION
    if (this.preloadedVideos.has(src)) return;
    this.preloadedVideos.add(src);
  
    var link = document.createElement('link');
    link.rel = mode; // 'preload' OR 'prefetch'
    link.href = src;
    link.setAttribute('data-video', src);
  
    document.head.appendChild(link);
  },
  

  // ---------------------------------------------------
  // CLEANUP
  // ---------------------------------------------------
  destroyVideo: function () {
    if (!this.activeVideo) return;

    this.activeVideo.pause();
    this.activeVideo.removeAttribute('src');
    this.activeVideo.load();
    this.activeVideo.remove();

    this.activeVideo = null;
  }
};


// =====================================================
// HASHCHANGE HANDLER (BACK / FORWARD SUPPORT)
// =====================================================
window.addEventListener('hashchange', function () {
  var sceneId = location.hash.replace('#', '');
  if (!sceneId) return;
  if (!app.currentScene) return;
  if (app.currentScene.id === sceneId) return;

  app.goToScene(sceneId);
});

  
  const coreScenes = [
    {
      id: 'intro',
      type: 'video',
      autoplay: true,
      muted: true,
      forceMutedAutoplay: true, 
      video: {
        desktop: '/intro-videos/Intro-PSA.mp4',
        mobile: '/intro-videos/mobile-PSA2025-intro-v3.mp4'
      },
      trigger: 'button',
      next: 'splash'
    },
    {
      id: 'splash',
      type: 'video',
      allowAudioOnMobile: true,
      volume: 0.3,
      video: {
        desktop: '/videos/Main-intro.mp4',
        mobile: '/videos/Main-intro-mobile.mp4'
      },
      trigger: 'ended',
      next: 'home'
    },
    {
      id: 'home',
      type: 'static',
      trigger: 'button',
      next: 'welcome'
    },
    {
      id: 'welcome',
      type: 'video',
      video: {
        desktop: '/videos/VR-Headset-Intro.mp4',
        mobile: '/videos/VR-Headset-Intro-mobile.mp4'
      },
      trigger: 'button',
      next: 'who-we-are'
    },
    {
      id: 'who-we-are',
      type: 'video',
      loop: false,
      video:{
        desktop: '/videos/who-we-are-2.mp4',
        mobile: '/videos/who-we-are-mobile.mp4'
      },
      trigger: 'button',
      next: 'business-overview'
    },
    {
      id: 'business-overview',
      type: 'video',
      video:{
        desktop: '/videos/Busines_Overview_Precise_Starlight_Quality.mp4',
        mobile: '/videos/Busines_Overview_Precise_Starlight_Quality-mobile.mp4'
      },
      trigger: 'button'
    },
    {
      id: 'financial-highlights',
      type: 'video',
      video:{
        desktop: '/videos/Financial-highlights_Creative_Bold.mp4',
        mobile: '/videos/Financial-highlights_Creative_Bold-mobile.mp4'
      },
      trigger: 'button'
    }
  ];

  const chapters = [
    {
      intro: {
        id: 'chapter-1-intro',
        type: 'video',
        allowAudioOnMobile: true,
        video: {
          desktop: '/videos/chapter1-intro.mp4',
          mobile: '/videos/Chapter1-mobile.mp4'
        },
        trigger: 'ended',
        next: 'chapter-1'
      },
      main: {
        id: 'chapter-1',
        type: 'static',
        trigger: 'button'
      }
    },
    {
      intro: {
        id: 'chapter-2-intro',
        type: 'video',
         allowAudioOnMobile: true,
        video: {
          desktop: '/videos/chapter2-intro.mp4',
          mobile: '/videos/Chapter2-mobile.mp4'
        },
        trigger: 'ended',
        next: 'chapter-2'
      },
      main: {
        id: 'chapter-2',
        type: 'static',
        trigger: 'button'
      }
    },
    {
      intro: {
        id: 'chapter-3-intro',
        type: 'video',
        allowAudioOnMobile: true,
        video: {
          desktop: '/videos/chapter3-intro.mp4',
          mobile: '/videos/Chapter3-mobile.mp4'
        },
        trigger: 'ended',
        next: 'chapter-3'
      },
      main: {
        id: 'chapter-3',
        type: 'static',
        trigger: 'button'
      }
    },
    {
      intro: {
        id: 'chapter-4-intro',
        type: 'video',
        allowAudioOnMobile: true,
        video: {
          desktop: '/videos/chapter4-intro.mp4',
          mobile: '/videos/Chapter4-mobile.mp4'
        },
        trigger: 'ended',
        next: 'chapter-4'
      },
      main: {
        id: 'chapter-4',
        type: 'static',
        trigger: 'button'
      }
    },
    {
      intro: {
        id: 'chapter-5-intro',
        type: 'video',
        allowAudioOnMobile: true,
        video: {
          desktop: '/videos/chapter5-intro.mp4',
          mobile: '/videos/Chapter5-mobile.mp4'
        },
        trigger: 'ended',
        next: 'chapter-5'
      },
      main: {
        id: 'chapter-5',
        type: 'static',
        trigger: 'button'
      }
    },
    {
      intro: {
        id: 'chapter-6-intro',
        type: 'video',
        allowAudioOnMobile: true,
        video: {
          desktop: '/videos/chapter6-intro.mp4',
          mobile: '/videos/Chapter6-mobile.mp4'
        },
        trigger: 'ended',
        next: 'chapter-6'
      },
      main: {
        id: 'chapter-6',
        type: 'static',
        trigger: 'button'
      }
    }
  ];
  
  app.scenes = [
    ...coreScenes,
    ...chapters.flatMap(ch => [ch.intro, ch.main])
  ];
  

  

  jQuery(document).ready(function () {
    app.init();
    initHeroVideoPreloader();
  });
  

 // ✅ Handles iOS Safari + all browsers
    window.addEventListener('resize', function () {
      app.handleResize();
    });

    // ✅ Extra safety for iOS
    window.addEventListener('orientationchange', function () {
      setTimeout(function () {
        app.handleResize();
      }, 300);
    });
  

  function initHeroVideoPreloader() {

    var preloaderVideo = document.getElementById('preloader-video');

    if (preloaderVideo) {
      preloaderVideo.muted = true;
      preloaderVideo.loop = true;

      preloaderVideo.play().catch(function () {
        // Safari may delay; retry shortly
        setTimeout(function () {
          preloaderVideo.play().catch(function () {});
        }, 100);
      });
}


      var videos = document.querySelectorAll('.hero video');
      if (!videos.length) return;

      var preloader = document.getElementById('page-preloader');
      var content = document.getElementById('page-content');

      var readyCount = 0;
      var total = videos.length;

      function revealPage() {
        if (preloaderVideo) {
          preloaderVideo.pause();
          preloaderVideo.currentTime = 0;
        }

        
        if (preloader) preloader.style.display = 'none';
        if (content) content.classList.remove('is-hidden');

        // ✅ Activate app UI
        document.querySelectorAll('.app-ui').forEach(function (el) {
          el.classList.add('is-active');
        });

        // ✅ Play ALL hero videos
        videos.forEach(function (video) {
          // enforce loop for overlay videos
          if (video.classList.contains('overlay-video')) {
            video.loop = true;
          }
        
          // force muted autoplay (mobile-safe)
          video.muted = true;
          video.autoplay = true;
        
          video.play().catch(function () {
            // Safari sometimes needs a second frame
            setTimeout(function () {
              video.play().catch(function () {});
            }, 100);
          });
        });
        
      }

      function onVideoReady() {
        readyCount++;
        if (readyCount >= total) {
          revealPage();
        }
      }

      // Safety fallback (never get stuck)
      var fallbackTimer = setTimeout(function () {
        revealPage();
      }, 6000);

      videos.forEach(function (video) {
        // If already ready (cached)
        if (video.readyState >= 3) {
          onVideoReady();
          return;
        }

        video.addEventListener('canplay', onVideoReady, { once: true });
        video.addEventListener('error', onVideoReady, { once: true });
      });
    
       
  }
  
    document.addEventListener("DOMContentLoaded", () => {
      const counters = document.querySelectorAll(".stat-number");

      counters.forEach(counter => {
          const target = +counter.dataset.target;
          const suffix = counter.dataset.suffix || "";
          const duration = 2000;
          const startTime = performance.now();

          function update(currentTime) {
              const elapsed = currentTime - startTime;
              const progress = Math.min(elapsed / duration, 1);
              const value = Math.floor(progress * target);

              counter.textContent = value + suffix;

              if (progress < 1) {
                  requestAnimationFrame(update);
              } else {
                  counter.textContent = target + suffix;
              }
          }

          requestAnimationFrame(update);
      });
    });


    function initMouseParallax() {
      const elements = document.querySelectorAll('[data-mouse-speed]');
      if (!elements.length) return;
    
      let mouseX = 0;
      let mouseY = 0;
    
      let currentX = 0;
      let currentY = 0;
    
      const ease = 0.08; // lower = smoother (0.05–0.12 sweet spot)
    
      function animate() {
        // LERP (smooth interpolation)
        currentX += (mouseX - currentX) * ease;
        currentY += (mouseY - currentY) * ease;
    
        elements.forEach(el => {
          const speed = parseFloat(el.dataset.mouseSpeed) || 20;
    
          // el.style.transform = `
          //   translate(
          //     ${-currentX * speed}px,
          //     ${-currentY * speed}px
          //   )
          // `;

          el.style.transform = `
            translate(${ -currentX * speed }px, ${ -currentY * speed }px)
            rotateY(${ currentX * 2 }deg)
            rotateX(${ -currentY * 2 }deg)
          `;

        });
    
        requestAnimationFrame(animate);
      }
    
      document.addEventListener('mousemove', function (e) {
        mouseX = (e.clientX / window.innerWidth - 0.5) * 2;
        mouseY = (e.clientY / window.innerHeight - 0.5) * 2;
      });
    
      animate();
    }
    
    document.addEventListener('DOMContentLoaded', initMouseParallax);
    
    